import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as n, normalizeClass as o, createElementVNode as r } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconUnread",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  d: "M2.146 2.146A.5.5 0 0 1 2.5 2h3a.5.5 0 0 0 0-1h-3A1.5 1.5 0 0 0 1 2.5v8a.5.5 0 0 0 .854.354L3.707 9H9.5A1.5 1.5 0 0 0 11 7.5V6.25a.5.5 0 1 0-1 0V7.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 0-.354.146L2 9.293V2.5a.5.5 0 0 1 .146-.354Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ r("path", {
  d: "M9.25 1a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z",
  fill: "currentColor"
}, null, -1), h = [
  _,
  u
];
function m(e, f, i, p, b, a) {
  return n(), d("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--unread"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Unread",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const I = /* @__PURE__ */ s(l, [["render", m]]);
export {
  I as default
};
//# sourceMappingURL=unread.js.map
